import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as authLogin, logout as authLogout, isAuthenticated } from '../services/authService';

const AuthContext = createContext(null);

export const USER_ROLES = {
  YONETICI: 'Yönetici',
  OPERASYON_SEFI: 'Operasyon Şefi',
  PERSONEL: 'Personel',
  SOFOR: 'Şöför'
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const [userDetails, setUserDetails] = useState(() => {
    const storedDetails = localStorage.getItem('userDetails');
    return storedDetails ? JSON.parse(storedDetails) : null;
  });

  useEffect(() => {
    // Check authentication status on mount
    setIsLoggedIn(isAuthenticated());
    const storedDetails = localStorage.getItem('userDetails');
    if (storedDetails) {
      setUserDetails(JSON.parse(storedDetails));
    }
  }, []);

  const login = async (credentials) => {
    try {
      const response = await authLogin(credentials.username, credentials.password,credentials.token);
      const userInfo = {
        userId: response.uyeId,
        fullName: response.adsoyad,
        role: response.rolAdi,
        roleId: response.rolId
      };
      setUserDetails(userInfo);
      localStorage.setItem('userDetails', JSON.stringify(userInfo));
      setIsLoggedIn(true);
      return response;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await authLogout();
      setIsLoggedIn(false);
      setUserDetails(null);
      localStorage.removeItem('userDetails');
    } catch (error) {
      console.error('Logout failed:', error);
      throw error;
    }
  };

  const hasPermission = (requiredRole) => {
    if (!userDetails) return false;
    
    switch (userDetails.role) {
      case USER_ROLES.YONETICI:
        return true; // Yönetici has access to everything
        case USER_ROLES.OPERASYON_SEFI:
          return requiredRole !== USER_ROLES.YONETICI;
      case USER_ROLES.SOFOR:
        return requiredRole !== USER_ROLES.YONETICI;
      case USER_ROLES.PERSONEL:
        return requiredRole === USER_ROLES.PERSONEL;
      default:
        return false;
    }
  };

  return (
    <AuthContext.Provider 
      value={{ 
        isLoggedIn, 
        login, 
        logout,
        userDetails,
        hasPermission
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 